import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { ENDPOINTS } from '@/api/endpoints';
import { fetchClient } from '@/api/fetch-client';
import { GetUrgencyCategoryError, GetUrgencyCategoryResponse } from '@/api/model';

const KEY = {
  GET_URGENCY_CATEGORY: 'GET_URGENCY_CATEGORY',
} as const;

const request = {
  getUrgencyCategory: async (signal?: AbortSignal) => {
    const { data } = await fetchClient.FCT.get<GetUrgencyCategoryResponse>(
      ENDPOINTS.FCT.REPORT.URGENCY_CATEGORY,
      { signal },
    );

    return data;
  },
};

const query = {
  useGetUrgencyCategory: (
    config?: Partial<UseQueryOptions<GetUrgencyCategoryResponse, GetUrgencyCategoryError>>,
  ) =>
    useQuery<GetUrgencyCategoryResponse, GetUrgencyCategoryError>({
      queryFn: ({ signal }) => request.getUrgencyCategory(signal),
      queryKey: [KEY.GET_URGENCY_CATEGORY],
      ...config,
    }),
};

export const urgencyCategory = {
  KEY,
  query,
  request,
};
